import { render, staticRenderFns } from "./fbpClaimBills.vue?vue&type=template&id=4cc716b4&scoped=true"
import script from "./fbpClaimBills.vue?vue&type=script&lang=js"
export * from "./fbpClaimBills.vue?vue&type=script&lang=js"
import style0 from "./fbpClaimBills.vue?vue&type=style&index=0&id=4cc716b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc716b4",
  null
  
)

export default component.exports